import { IPagePanelFooter } from 'edenred-ui';
import React, { ReactNode } from 'react';

import { IBenefitType, IBenefits } from '@epi-models/pages/BenefitGroups';
import { TopupFormStatusesType } from '@epi-constants/topupForm';

import { IBeneficiary } from './Beneficiaries';

export interface ISwitchProps {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export interface BeneficiariesResponse {
  beneficiaries: IBeneficiary[];
}

export interface ITopupProps {
  updateFooter: (footer?: IPagePanelFooter) => void;
}
export interface TopupInProgressResponse {
  isTopUpLoadInProgress: boolean;
  ids: string[];
}

export interface TopupResponse {
  topUpLoadId: string | number;
}

export interface TopupEmployeesResponse {
  isTopUpLoadProcessingInProgress: true;
  availableBenefitSettings: [
    {
      benefitType: IBenefitType;
      feePercentage: number;
      maxLoadAmount: number;
      maxWorkingDays?: number;
    }
  ];
  beneficiaries: [
    {
      fundsLoadingType: string;
      personalId: string;
      firstName: string;
      lastName: string;
      emailAddress: string;
      beneficiaryId: number;
      city: string;
      totalTopUpedAmount: number;
      availableToTopUpAmount: number;
      employmentType: string;
      benefitPercentage: number;
      remainingDays?: number;
      groupName: string;
    }
  ];
  currentLunchFundsLoadingType: string;
  isLunchFundsLoadingTypePending: boolean;
  anyDeferredCardOrders: boolean;
}

export interface UseTopupEmployeesProps {
  paginationCount: number;
  toggleEmployee: (employee: Employee) => void;
  visibleEmployees: Employee[];
  handleSort: (sortBy: string) => void;
  descending: boolean;
  sortBy: string;
  checkedCount: number;
  employeesPerPage: number;
  employeesToTopup: Employee[];
  employeesCount: number;
  lowestAvailable: number;
  topupBeneficiariesIds: number[];
  isToggle: boolean;
  handleToggler: () => void;
  toggleAllEmployee: (isChecked: boolean) => void;
  isOnHoldEmployee: boolean;
  isAllEmployeeChecked: boolean;
  setForceUpdate: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface TopupSummaryResult {
  formattedTopup: string;
  formattedFee: string;
  formattedVat: string;
  formattedTopupWithFees: string;
  formattedRemainingBalance: string;
  remainingBalance: number;
  fee: number;
  vat: number;
}

export interface TopupSummaryProps {
  formattedTopup: string;
  formattedFee: string;
  formattedVat: string;
  formattedTopupWithFees: string;
  formattedRemainingBalance: string;
  remainingBalance: number;
  fee: number;
  vat: number;
  showRemainingBalance: boolean;
}

export interface TopupFormProps {
  updateFooter: (footerProps?: IPagePanelFooter) => void;
}

export interface TopupRequestPayload {
  amount: string;
  benefitType: IBenefits;
  beneficiariesIds: number[];
}

export interface TopupInProgressProps {
  setShowTopupForm: (show: boolean) => void;
  isTopupProcessing: boolean;
  summaryId?: string | number;
  loadableBenefits: string[];
  setForceUpdate: (update: boolean) => void;
}

export interface TopupConfirmationModalProps {
  showModal: boolean;
  handleTopupRequest: () => void;
  handleCloseModal: () => void;
  employeesCount: number;
  totalAmount: string;
  isTopupPending: boolean;
  showOnHoldText: boolean;
  isPendingBenefit: boolean;
  topupAmount: string;
  showOnboardingContent: boolean;
  topupRequestStatus: TopupFormStatusesType | null;
  resetTopupStatus: () => void;
  isBatchOrder: boolean;
  isAdminTopup?: boolean;
}

export interface Employee {
  beneficiaryId: number;
  personalId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  employmentType: string;
  benefitPercentage?: number;
  availableToTopUpAmount: number;
  isChecked: boolean;
  disabled?: boolean;
  onHold?: boolean;
  remainingDays?: number;
  loadValue?: number;
  fundsLoadingType: string;
  groupName: string;
}

export interface EmployeesTableProps {
  visibleEmployees: Employee[];
  toggleEmployee: (employee: Employee) => void;
  handleChangePage: (page: number) => void;
  paginationCount: number;
  page: number;
  employeesPerPage: number;
  handleSort: (sortType: string) => void;
  descending: boolean;
  sortBy: string;
  checkedCount: number;
  toggleAllEmployee: (checked: boolean) => void;
  isAllEmployeeChecked: boolean;
}

export interface FormStepLabelProps {
  mode?: FormStepMode;
  stepNumber: number;
  stepTitle: string;
  children?: ReactNode;
}

export interface SimpleFormStepProps {
  stepNumber: number;
  stepTitle: string;
  children: ReactNode;
  mode?: FormStepMode;
  pr?: string;
}

export enum FormStepMode {
  Contained = 'contained',
  Outlined = 'outlined'
}

export interface FormStepProps {
  mode?: FormStepMode;
  children: React.ReactNode;
  stepNumber: number;
}

export type CompanyBeneficariesSsnRequestParams = {
  beneficiaryPersonId: number;
  abortController: AbortController | null;
};

export interface CompanyBeneficiariesSsnResponse {
  personalId: string;
}
